import { COUNTRY_INFO } from 'src/formio/components/PhoneField/utils';

export const getMaskByIsoPhone = (code: string, phone: string): string => {
    const countryData = COUNTRY_INFO.find((item) => item.iso === code);

    if (!countryData) return phone.replace(/\d/g, '9');

    return `${countryData?.code} ${countryData?.mask}`?.replace(/#/g, '9');
};
